{
  "charts": {
    "dateLabel": "Date: {{date}}",
    "completion": {
      "title": "Completion Rate by Course",
      "description": "Top-performing courses",
      "overallAverage": "Overall Average",
      "levels": {
        "excellent": "Excellent",
        "good": "Good",
        "fair": "Fair",
        "low": "Low"
      },
      "tooltipLabel": "Completion Rate",
      "tooltipDetail": "{{completed}} of {{total}} enrollments completed",
      "legend": {
        "excellent": "Excellent (≥80%)",
        "good": "Good (60-79%)",
        "fair": "Fair (40-59%)",
        "low": "Low (<40%)"
      }
    },
    "engagement": {
      "title": "Engagement Metrics",
      "description_one": "Daily activity over the last {{count}} day",
      "description_zero": "Daily activity over the last {{count}} days",
      "description_other": "Daily activity over the last {{count}} days",
      "uniqueUsers": "Unique Users",
      "sessions": "Sessions",
      "pageViews": "Page Views"
    },
    "retention": {
      "loadingTitle": "Retention Analysis",
      "title": "User Retention Analysis",
      "description": "Retention rate by cohort over the last 10 days",
      "newUsers": "New Users",
      "day": "Day {{day}}",
      "retentionDay": "Day {{day}} Retention"
    }
  },
  "tabs": {
    "overview": "Overview",
    "students": "Students",
    "lessons": "Lessons",
    "payments": "Payments",
    "courses": "Courses"
  },
  "paymentStatus": {
    "paid": "Paid",
    "refunded": "Refunded",
    "chargeback": "Chargeback",
    "pending": "Pending",
    "cancelled": "Cancelled"
  },
  "paymentMethods": {
    "creditCard": "Card",
    "debitCard": "Debit",
    "pix": "PIX",
    "boleto": "Boleto",
    "bankTransfer": "Transfer"
  },
  "page": {
    "title": "Dashboard",
    "subtitle": "Complete platform overview",
    "loading": "Loading dashboard...",
    "loadError": "Failed to load dashboard data",
    "realTime": "Real time"
  },
  "stats": {
    "totalRevenue": "Total Revenue",
    "monthlyRevenue": "Monthly Revenue",
    "averageTicket": "Average Order Value",
    "averageTicketSub": "Average value per sale",
    "users": "Users",
    "activeCourses": "Active Courses",
    "completion": "Lesson completion",
    "refund": "Refunds",
    "chargeback": "Chargebacks",
    "refundChargeback": "Refunds / Chargebacks",
    "chargebackSub": "Chargebacks: {{rate}}%",
    "salesCount_one": "{{count}} sale",
    "salesCount_zero": "{{count}} sales",
    "salesCount_other": "{{count}} sales",
    "salesThisMonth_one": "{{count}} sale this month",
    "salesThisMonth_zero": "{{count}} sales this month",
    "salesThisMonth_other": "{{count}} sales this month",
    "enrollmentsCount_one": "{{count}} enrollment",
    "enrollmentsCount_zero": "{{count}} enrollments",
    "enrollmentsCount_other": "{{count}} enrollments"
  },
  "series": {
    "revenue": "Revenue",
    "refunds": "Refunds",
    "sales": "Sales",
    "enrollments": "Enrollments",
    "completions": "Completions",
    "amount": "Amount"
  },
  "overview": {
    "monthlyRevenueTitle": "Monthly Revenue (12 months)",
    "salesPerMonth": "Sales per Month",
    "enrollmentsVsCompletions": "Enrollments vs Completions",
    "coursesByCategory": "Courses by Category",
    "topCourses": "Top Courses",
    "studentsCount_one": "{{count}} student",
    "studentsCount_zero": "{{count}} students",
    "studentsCount_other": "{{count}} students",
    "noCourses": "No courses found",
    "noCategories": "No categories"
  },
  "payments": {
    "methods": "Payment Methods",
    "noSalesRecorded": "No sales recorded",
    "recentSales": "Recent Sales",
    "noSalesYet": "No sales yet",
    "noSalesYetDescription": "Sales will appear here once they are processed",
    "revenueAndSalesTitle": "Revenue and Sales (12 months)"
  },
  "students": {
    "unavailable": "Student data unavailable",
    "enrollmentStatus": {
      "active": "Active",
      "expired": "Expired",
      "cancelled": "Cancelled"
    },
    "total": "Total Students",
    "newThisMonth_one": "{{count}} new this month",
    "newThisMonth_zero": "{{count}} new this month",
    "newThisMonth_other": "{{count}} new this month",
    "newToday": "New Today",
    "thisWeek_one": "{{count}} this week",
    "thisWeek_zero": "{{count}} this week",
    "thisWeek_other": "{{count}} this week",
    "dau": "Active Users (DAU)",
    "withEnrollments": "With Enrollments",
    "ofTotal": "{{rate}}% of total",
    "verifiedEmails": "Verified Emails",
    "withCompletions": "With Completions",
    "completionRate": "Students with completion",
    "newPerDayTitle": "New Students per Day (30 days)",
    "newStudents": "New students",
    "enrollmentsByStatus": "Enrollments by Status",
    "noEnrollments": "No enrollments recorded",
    "activeUsers": "Active Users",
    "activeToday": "Active Today",
    "activeTodaySub": "Unique users in the last 24h",
    "activeWeek": "Active This Week",
    "activeWeekSub": "Unique users in the last 7 days",
    "activeMonth": "Active This Month",
    "activeMonthSub": "Unique users in the last 30 days",
    "engagement": "Engagement (Active Today / Active This Month)",
    "recentEnrollments": "Recent Enrollments",
    "noRecentEnrollments": "No recent enrollments"
  },
  "lessons": {
    "unavailable": "Lesson data unavailable",
    "total": "Total Lessons",
    "started_one": "{{count}} started",
    "started_zero": "{{count}} started",
    "started_other": "{{count}} started",
    "completed": "Completed Lessons",
    "completionRate": "{{rate}}% completion",
    "watchedWeek": "Watched (Week)",
    "thisMonth_one": "{{count}} this month",
    "thisMonth_zero": "{{count}} this month",
    "thisMonth_other": "{{count}} this month",
    "averageProgress": "Average Progress",
    "sessions_one": "{{count}} session",
    "sessions_zero": "{{count}} sessions",
    "sessions_other": "{{count}} sessions",
    "activityTitle": "Lesson Activity per Day (30 days)",
    "watched": "Watched",
    "completedSeries": "Completed",
    "mostWatched": "Most Watched Lessons",
    "views": "views",
    "completions": "completed",
    "noneWatched": "No lessons watched",
    "recentCompleted": "Recently Completed Lessons"
  },
  "courses": {
    "published": "Published Courses",
    "inDevelopment_one": "{{count}} in development",
    "inDevelopment_zero": "{{count}} in development",
    "inDevelopment_other": "{{count}} in development",
    "totalEnrollments": "Total Enrollments",
    "completionRate": "Course completion",
    "categories": "Categories",
    "performance": "Performance by Course",
    "modules_one": "{{count}} module",
    "modules_zero": "{{count}} modules",
    "modules_other": "{{count}} modules",
    "enrollments": "enrollments",
    "active": "active",
    "completed": "completed",
    "progress": "progress",
    "completion": "completion",
    "noPublished": "No published courses",
    "categoryDistribution": "Distribution by Category",
    "completionByCourse": "Completion Rate by Course",
    "recentCompletions": "Recent Course Completions"
  }
}
